import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
class FallbackErrorBoundary extends React.Component {
    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error
        };
    }
    render() {
        if (this.state.hasError) {
            return this.props.fallback(this.state.error, this.clearError);
        }
        return this.props.children;
    }
    constructor(...args){
        super(...args), _define_property(this, "state", {
            hasError: false,
            error: null
        }), _define_property(this, "clearError", ()=>this.setState({
                hasError: false
            }));
    }
}
export { FallbackErrorBoundary as default };

//# sourceMappingURL=FallbackErrorBoundary.js.map